import ColumnBandCells from './ColumnBandCells'
import JourneyRow from './JourneyRow'
import StepRow from './StepRow'
import styles from '../../ProjectStoryMapBoard.module.css'

const MapTopSection = ({
    boardTracks,
    gridTemplateColumns,
    journeys,
    editingJourneyId,
    editingJourneyDraft,
    journeyInputRef,
    journeyMenu,
    onDraftChange,
    onCommitJourneyTitle,
    onInsertJourneyAt,
    onInsertStepAt,
    onOpenJourney,
    onOpenStep,
    editingStepId,
    editingStepDraft,
    stepInputRef,
    onStepDraftChange,
    onCommitStepTitle,
    draggingStepJourneyId,
    stepDragPlaceholder,
    stepMenu,
    highlightedCardId,
    isFilterActive = false,
    filterFocusedCardId = null,
    readOnly = false,
}) => (
    <div className={styles.mapTopSection}>
        <div
            className={styles.columnBandBackdrop}
            style={{ gridTemplateColumns }}
        >
            <ColumnBandCells tracks={boardTracks} keyPrefix="top" />
        </div>

        <div
            className={`${styles.boardColumnGrid} ${styles.journeyGrid}`}
            style={{ gridTemplateColumns }}
        >
            <JourneyRow
                journeys={journeys}
                boardTracks={boardTracks}
                editingJourneyId={editingJourneyId}
                editingJourneyDraft={editingJourneyDraft}
                journeyInputRef={journeyInputRef}
                journeyMenu={journeyMenu}
                onDraftChange={onDraftChange}
                onCommitJourneyTitle={onCommitJourneyTitle}
                onInsertJourneyAt={onInsertJourneyAt}
                onOpenJourney={onOpenJourney}
                isFilterActive={isFilterActive}
                filterFocusedCardId={filterFocusedCardId}
                readOnly={readOnly}
            />
        </div>

        <div className={styles.stepSection}>
            <div
                className={`${styles.boardColumnGrid} ${styles.stepGrid}`}
                style={{ gridTemplateColumns }}
            >
                <StepRow
                    boardTracks={boardTracks}
                    journeys={journeys}
                    onInsertStepAt={onInsertStepAt}
                    onOpenStep={onOpenStep}
                    editingStepId={editingStepId}
                    editingStepDraft={editingStepDraft}
                    stepInputRef={stepInputRef}
                    onStepDraftChange={onStepDraftChange}
                    onCommitStepTitle={onCommitStepTitle}
                    draggingStepJourneyId={draggingStepJourneyId}
                    stepDragPlaceholder={stepDragPlaceholder}
                    stepMenu={stepMenu}
                    highlightedCardId={highlightedCardId}
                    isFilterActive={isFilterActive}
                    filterFocusedCardId={filterFocusedCardId}
                    readOnly={readOnly}
                />
            </div>
        </div>
    </div>
)

export default MapTopSection
